import { useContext } from 'react';

import { type AuthState, AuthContext } from '@/contexts/AuthProvider';

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) {
    throw new Error('useAuth must be used within an <AuthProvider>');
  }
  return ctx;
}
